<template>
  <v-app>
    <Header ref="header"/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout wrap>
          <v-flex text-xs-left xs12 md3 px-3>
            <v-text-field v-model="search" append-icon="search" placeholder="Search" style="padding-bottom: 0 !important;"></v-text-field>
          </v-flex>
          <v-flex text-xs-left xs12 md9 px-3 style="padding-top: 6px;">
            <v-select :items="maxValues" v-model="max" return-object @change="loadLogs" style="width: 80px; padding-bottom: 5px !important;"></v-select>
          </v-flex>
          <v-flex text-xs-left xs12 md6 px-3 style="padding-right: 40px !important;">
            <v-select :items="filterUsers" v-model="filterUser" item-text="fullName" prepend-icon="fa-user" return-object @change="loadLogs" class="userFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md6 px-3>
            <table>
              <tr>
                <td>
                  <v-menu v-model="filterDateFromMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="filterDateFrom" prepend-icon="event" readonly style="width: 140px;" v-on="on" clearable class="dateField"/>
                    </template>
                    <v-date-picker v-model="filterDateFrom" @input="filterDateFromMenu = false" @change="dateFromChanged"/>
                  </v-menu>
                </td>
                <td style="padding-left: 20px;">&nbsp;</td>
                <td>
                  <v-menu v-model="filterDateToMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="filterDateTo" prepend-icon="event" readonly style="width: 140px;" v-on="on" clearable class="dateField"/>
                    </template>
                    <v-date-picker v-model="filterDateTo" @input="filterDateToMenu = false" :min="filterDateFrom" @change="dateToChanged"/>
                  </v-menu>
                </td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3>
        <v-layout style="max-height: calc(100vh - 205px);">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="logs" :search="search" class="logTable" hide-actions v-bind:pagination.sync="pagination">
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left colTimestamp">{{ props.item.timestamp }}</td>
                  <td class="text-xs-left colTimestamp">{{ props.item.clientTimestamp }}</td>
                  <td class="text-xs-left colUsername">{{ props.item.userFullName }}</td>
                  <td class="text-xs-left colMessage">{{ props.item.shipmentNumber }}</td>
                  <td class="text-xs-left colMessage">{{ props.item.palletNumber }}</td>
                  <td class="text-xs-left colMessage">{{ props.item.message }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import PanelColumn from '../components/PanelColumn'
import axios from 'axios'

export default {
  name: 'Log',
  components: { Header, Sidebar, Footer, Panel, PanelColumn },
  data () {
    return {
      search: '',
      refreshInterval: null,
      headers: [
        { text: 'Received', value: 'timestamp', sortable: true, descending: true },
        { text: 'Timestamp', value: 'clientTimestamp', sortable: true },
        { text: 'User', value: 'userFullName', sortable: true },
        { text: 'Shipment', value: 'shipmentNumber', sortable: true },
        { text: 'Pallet', value: 'palletNumber', sortable: true },
        { text: 'Message', value: 'message', sortable: false }
      ],
      logs: [],
      maxValues: [ 50, 250, 500, 2500, 5000, 10000, 'All' ],
      max: 50,
      filterUsers: [],
      filterUser: { id: 0 },
      filterDateFrom: null,
      filterDateFromMenu: false,
      filterDateTo: null,
      filterDateToMenu: false,
      pagination: {
        sortBy: 'timestamp',
        descending: true,
        rowsPerPage: -1
      }
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'log' })
    this.loadFilterUsers()
    this.refreshLogs()
    let refreshMethod = this.refreshLogs
    this.refreshInterval = setInterval(function () {
      refreshMethod()
    }, 60000)
  },
  beforeDestroy: function () {
    clearInterval(this.refreshInterval)
  },
  computed: {
  },
  methods: {
    loadFilterUsers () {
      axios.get('/backend/rest/user')
        .then(response => {
          let filterUsers = response.data
          filterUsers.splice(0, 0, {
            id: 0,
            fullName: ''
          })
          this.filterUsers = filterUsers
        })
    },
    dateFromChanged () {
      if (this.filterDateFrom !== '' && this.filterDateTo !== '' && this.filterDateFrom.localeCompare(this.filterDateTo) > 0) {
        this.filterDateTo = null
      }
    },
    dateToChanged () {
    },
    loadLogs () {
      let max = typeof this.max === 'number' ? this.max : 0
      let userId = this.filterUser ? this.filterUser.id : ''
      let from = this.filterDateFrom ? this.filterDateFrom : ''
      let to = this.filterDateTo ? this.filterDateTo : ''
      // console.log('Loading ' + (max === 0 ? 'all ' : '') + 'latest ' + (max > 0 ? max + ' ' : '') + 'log entries')
      axios.get('/backend/rest/log/search?max=' + max + '&user=' + userId + '&from=' + from + '&to=' + to)
        .then(response => {
          // console.log('Response data: ' + Object.keys(response))
          this.logs = response.data
        })
    },
    refreshLogs () {
      this.loadLogs()
    }
  },
  watch: {
    filterDateFrom (val) {
      this.loadLogs()
    },
    filterDateTo (val) {
      this.loadLogs()
    }
  }}
</script>
<style scoped>
  .logTable table.v-table tbody td {
    height: 24px !important;
  }
  .colTimestamp {
    white-space: nowrap;
  }
  .colUsername {
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Log.vue